import Navbar from '../components/Navbar.js';
import Landing from '../components/Landing.js';
import About from '../components/AboutUs.js';
import ProjectCustomization from '../components/ProjectCustomization.js';
import OurStrengths from '../components/OurStrengths.js';

import './HomeView.css';

const HomeView = () => {

    return (
        <div className="HomeView">
            <Navbar />
            <Landing />
            <About />
            <ProjectCustomization />
            <OurStrengths />
        </div>
    )
}

export default HomeView;